<template>
    <div
        class="filter-option hover:text-hh-cyan cursor-pointer"
        :ref="'option-' + item.reference"
        :class="{ 'active': isActive, 'opacity-100': ! isLoading, 'opacity-0': isLoading, 'pointer-events-none opacity-50' : isDisabled && ! isActive }"
        :data-filter-reference="category"
        :data-selected-value="isActive ? item.reference : ''"
        @click.prevent="toggle"
    >
        <div class="flex flex-shrink-0 filter-option-checkbox relative w-6 h-6 mr-3 border border-hh-cyan rounded overflow-hidden">
            <div class="filter-option-icon-container absolute left-0 w-full h-full">
                <div class="filter-option-icon checkmark w-full h-6 bg-center bg-no-repeat"></div>
                <div class="filter-option-icon x w-full h-6 bg-center bg-no-repeat bg-hh-red"></div>
            </div>
        </div>
        <div class="flex items-center flex-grow" v-html="item.title"></div>
        <div :ref="'option-count-' + item.reference" class="filter-option-count mx-2 relative flex items-center" v-html="item.count"></div>
    </div>
</template>

<script>

export default {

    name: "Option",

    props: ['item', 'category'],


    data() {
        return {
            isLoading: true,
            isActive: false,
            isDisabled: false,
            isLinked: false,
        }
    },

    created() {
        this.isActive = this.item.selected;
        this.isDisabled = this.item.disabled;
        this.isLinked = this.item.isLinked;
    },

    mounted() {

        const referenceLoaders = document.querySelectorAll('[data-loader-reference="' + this.item.reference + '"]');

        referenceLoaders.forEach(referenceLoader => {
            referenceLoader.classList.add('opacity-0');
        })

        this.Bus.on('toggle-linked', (data) => {
            if (data.reference === this.item.reference) {
                this.isActive = data.isActive;
            }
        });

        // this.Bus.on('pre-clear-filter', (data) => {
        //     if (data.reference === this.item.reference) {
        //         console.log('clear 2');
        //         this.isActive = false;
        //     }
        // });

        this.isLoading = false;
    },

    methods: {
        toggle() {
            this.$refs['option-count-' + this.item.reference].focus();
            this.isActive = ! this.isActive;

            if (! this.isActive) {
                this.Bus.emit('filter-deselect', this.item.reference);
            }

            if (this.isLinked) {
                this.Bus.emit('toggle-linked', { 'reference': this.item.reference, 'isActive' : this.isActive });
            }

            this.$nextTick(() => {
                this.Bus.emit('filter-change');
            })

            this.$refs['option-' + this.item.reference].blur();
            this.$refs['option-count-' + this.item.reference].blur();
        }
    },

    computed: {

    },
}
</script>
